export const MAX_BUDGET_TARGETS_HOURS = 71582788;
export const MAX_BUDGET_TARGETS_COST = 42949672;
